import { fromEvent } from "file-selector";
import { COMMON_MIME_TYPES } from "file-selector/mime";
import type { DropzoneOptions } from "react-dropzone";

// Preserve extension fallback for browsers that leave File.type empty.
export const getDropFiles: NonNullable<DropzoneOptions["getFilesFromEvent"]> = (event) =>
  fromEvent(event, { mimeTypes: COMMON_MIME_TYPES });

type Rejection = {
  file: File;
  errors: readonly { code: string; message: string }[];
};

// A selection exceeding the limit must not silently upload its first files.
// react-dropzone 19+ accepts those files; our forms retain whole-batch rejection.
export function preserveBatchLimit(accepted: File[], rejected: readonly Rejection[]) {
  const overflow = rejected
    .flatMap((item) => item.errors)
    .find((error) => error.code === "too-many-files");
  if (!overflow) return { accepted, rejected };
  return {
    accepted: [],
    rejected: [...rejected, ...accepted.map((file) => ({ file, errors: [overflow] }))],
  };
}
